import type { RouteObject } from "react-router";
import { MEMBER_ROUTES } from "../constants/member-routes";

export const memberRoutes: RouteObject = {
	children: [
		{
			path: MEMBER_ROUTES.LIST,
			lazy: async () => {
				const { default: MemberListPage } = await import("../pages/member-list-page");
				return { Component: MemberListPage };
			},
		},
		{
			path: MEMBER_ROUTES.PROFILE,
			lazy: async () => {
				const { default: MyProfilePage } = await import("../pages/my-profile-page");
				return { Component: MyProfilePage };
			},
		},
		{
			path: MEMBER_ROUTES.DETAIL,
			lazy: async () => {
				const { default: MemberDetailPage } = await import("../pages/member-detail-page");
				return { Component: MemberDetailPage };
			},
		},
	],
};
